import styles from './Icons.module.css';
import { ReactComponent as Instagram } from 'assets/social-links/instagram.svg';

export const InstagramIcon = () => (
    <div className={styles['icon']}>
        <Instagram />
    </div>
);
